import React from 'react';
import {labelStyle, errorStyle, formStyle} from './styles/ValidationInput.css';

const ValidationInput = ({
  input,
  label,
  type,
  val,
  matchValue,
  mismatchMessage,
  otherTouched,
  meta: { touched, error, warning }
}) => {
  const errorSpan = () => {
    let errorMessage = '';
    if (touched && error) {
      errorMessage = error;
    } else if (touched && otherTouched && val !== matchValue) {
      errorMessage = mismatchMessage;
    }
    return <span style={errorStyle}>{errorMessage}</span>;
  };

  return (
    <div className="form-group" style={{ paddingBottom: '0' }}>
      <span style={labelStyle}>{label}</span>
      <input
        style={formStyle}
        {...input}
        className={`form-control form-control-lg ${
          touched && (error || (otherTouched && val !== matchValue))
            ? 'alert-danger'
            : null
        }`}
        type={type}
        autoComplete="off"
      />
      {errorSpan()}
    </div>
  );
};

export default ValidationInput;
